import { useRelationshipsContext } from '../providers/RelationshipsProvider';
import { Relationship } from '../types/types';

interface UseReferencePickerReturnType {
  addRelationships: (relationships: Relationship[]) => void;
}

/**
 * This hook allows getting/updating reference picker data.
 * It must be used inside `RelationshipsProvider` component.
 *
 * addRelationships - callback to add new relationship. Expects one argument - an array of new relationships to add.
 *
 * @returns {{addRelationships: function}}
 */
export default (): UseReferencePickerReturnType => {
  const { addRelationships } = useRelationshipsContext();
  return {
    addRelationships,
  };
};
